export default __webpack_public_path__ + "static/media/certificate.f8a9bc96.svg";